import styled from '@emotion/styled';

export const ListItem = styled.div`
	display: flex;
	justify-content: space-between;
	padding: var(--padding-5) 0;
	border-bottom: 1px solid var(--border-color);
`;

export const Hr = styled.hr`
	width: 100%;
	border: 0.5px solid var(--border-color);
`;

export const FooterWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin: var(--margin-3) 0;
`;
